import { onAuthStateChanged, signInWithPopup, signOut, type User } from "firebase/auth";
import { auth, googleProvider } from "./firebase";

export interface SessionUser {
  uid: string;
  name: string;
  email: string;
  photo: string;
}

export function toSession(user: User | null): SessionUser | null {
  if (!user) return null;
  return {
    uid: user.uid,
    name: user.displayName || user.email || "Usuario",
    email: user.email ?? "",
    photo: user.photoURL ?? "",
  };
}

export function watchAuth(cb: (user: SessionUser | null) => void): () => void {
  return onAuthStateChanged(auth, (user) => cb(toSession(user)));
}

export async function signInGoogle(): Promise<void> {
  await signInWithPopup(auth, googleProvider);
}

export async function signOutUser(): Promise<void> {
  await signOut(auth);
}
